import React from 'react';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseToolbarFeature from '../../../common/feature/base-toolbar-feature';
import PictureCorrectionPresetMenu from '@src/framework/frame-pc/components/palette-panel/effect-preset-menu/picture-correction-preset-menu';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { isImageOrImageFillShape } from '@src/slide/domain/ui-model/elements/element-judge';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { isPreviewOnly } from '@src/page/toc/common/check-client-vars';

const defaultPictureCorrectionsProps = {
    sharpenSoften: 0,
    brightness: 0,
    contrast: 0,
};
@Feature()
export class PictureCorrectionsFeature extends BaseToolbarFeature {
    id = config.id;
    config = config;
    private currentCorrectionsProps;

    public constructor() {
        super();
    }

    public shouldDisabled(): boolean {
        // 选中元素中只包含一个图片时才可用
        const model = this.getSelectModel() as IElementBaseModel;
        const models = getAllChildModels(model);
        const pictureModels = models.filter(isImageOrImageFillShape);
        return pictureModels.length !== 1 || isPreviewOnly();
    }

    public renderMenu() {
        const model = this.getFirstPictureModel();
        if (!model) return;
        const { sharpenSoften, brightness, contrast } = model.props.style.image || {};
        this.currentCorrectionsProps = { sharpenSoften, brightness, contrast };
        return <PictureCorrectionPresetMenu
            pictureProps={model.props}
            onPresetStyleClick={this.handlePresetStyleClick}
            onPresetStyleMouseEnter={this.handlePresetStyleMouseEnter}
            onPresetStyleMouseLeave={this.handlePresetStyleMouseLeave}
        />;
    }

    private getFirstPictureModel(): IPictureModel {
        const model = this.getSelectionService().getSelectedModel();
        const selectedModels = getAllChildModels(model as IElementBaseModel);
        return selectedModels.find(isImageOrImageFillShape) as IPictureModel;
    }

    private handlePresetStyleMouseEnter = (props) => {
        const updateProps = { ...props };
        this.getToolbarMenu()?.callback('', ActionType.REGULATE, updateProps, { onlyChangeUI: true, onlyPreview: true });
    };

    private handlePresetStyleMouseLeave = () => {
        this.getToolbarMenu()?.callback('', ActionType.REGULATE, this.currentCorrectionsProps, { onlyChangeUI: true, onlyPreview: true });
    };

    private handlePresetStyleClick = (props) => {
        const updateProps = { ...props };
        this.getToolbarMenu()?.callback('', ActionType.REGULATE, updateProps, { onlyChangeUI: false, onlyPreview: false });
    };
}
